import { withChartLayout } from 'components/common';
import LaborProgress from 'components/features/chart/vital-signs/labor-progress/LaborProgress';

const LaborProgressPage = withChartLayout('Labor Progress')(LaborProgress);
export default LaborProgressPage;
